// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
/**
 * Glossary Service
 *
 * A service to get additional info about a calc, including the definition and formula (if these are available for the
 * given metric).
 */
export class GlossaryService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getGlossaryCalcTerm(calcName) {
        const url = this.urlsService.getUrl(this.urlsService.GLOSSARY.GLOSSARY_CALC_TERM, { calcName });
        return this.ajaxService.getDataObserveBody(url);
    }
    getGlossaryData() {
        return this.ajaxService.getDataObserveBody(this.urlsService.GLOSSARY.GLOSSARY_DATA);
    }
    getGlossaryTermData(term) {
        const url = this.urlsService.getUrl(this.urlsService.GLOSSARY.GLOSSARY_TERM_DATA, { term });
        return this.ajaxService.getDataObserveBody(url);
    }
}
GlossaryService.ɵfac = function GlossaryService_Factory(t) { return new (t || GlossaryService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
GlossaryService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GlossaryService, factory: GlossaryService.ɵfac, providedIn: 'root' });
